// import * as L     from 'leaflet'
// import 'leaflet/dist/leaflet.css'
// import 'unfetch'
// import IconMapPin from '../images/icon-marker.svg'

document.addEventListener('app:load', init)

function init ()
{
	if (!document.body.classList.contains('page-template-acces'))
	{
		return
	}
	
	/*const showPlanButtons = document.querySelectorAll('#main .show-plan')
	
	showPlanButtons.forEach(_ =>
	{
		_.addEventListener('click', (e) =>
		{
			e.preventDefault()
			
			popup(_.nextElementSibling.cloneNode(true))
		})
	})*/
	
	// map()
}

/*function popup (img)
{
	const existingPopup = document.querySelector('#popup')
	
	if (existingPopup)
	{
		existingPopup.remove()
	}
	
	const div = document.createElement('div')
	const divInner = document.createElement('div')
	const divClose = document.createElement('div')
	
	div.id = 'popup'
	divInner.className = 'inner'
	divClose.className = 'close'
	
	divInner.appendChild(img)
	div.appendChild(divInner)
	div.appendChild(divClose)
	
	document.body.appendChild(div)
	
	setTimeout(() =>
	{
		div.classList.add('visible')
	}, 100)
	
	divClose.addEventListener('click', () =>
	{
		div.remove()
	})
}*/

function map ()
{
	const elMap = document.querySelector('#main .map')
	const latlng = [45.799062755161195, 4.629708451232409]
	
	const osmMapnik = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	})
	
	const cartoPositron = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
		attribution: '&copy; <a href="https://carto.com">Carto</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
	})
	
	const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
		maxZoom: 20,
		subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
	})
	
	const map = L.map(elMap, {
		// center: getLatLng(elMap.dataset.address),
		center: latlng,
		zoom: 18,
		maxBoundsViscosity: 1,
		attributionControl: true,
		zoomControl: true,
		scrollWheelZoom: true,
		gestureHandling: true
	})
	
	const marker = addMarker(this.map, latlng)
	
	map.addLayer(googleStreets)
	map.addLayer(marker)
	
	function addMarker (map, latlng)
	{
		const marker = L.marker(latlng, {
			icon: L.icon({
				iconUrl: IconMapPin,
				iconSize: [40, 40],
				iconAnchor: [20, 40],
				tooltipAnchor: [1, -45]
			}),
			opacity: 1,
			interactive: true,
			keyboard: false
		})
		
		/*marker.infos = el
		 
		 marker.on('mouseover', () => this.onMouseover(marker))
		 marker.on('mouseout', () => this.onMouseout(marker))
		 marker.on('click', (force) => this.onClick(marker, force))
		 marker.bindTooltip(el.title, {
		 direction: 'top',
		 permanent: true,
		 opacity: 0
		 })*/
		
		marker.bindTooltip(elMap.dataset.address.replaceAll('\n', '<br>'), {
			direction: 'top',
			permanent: true,
			opacity: 1
		})
		
		return marker
	}
	
	/*async function getLatLng (address, codePostal, ville, pays = 'France')
	 {
	 await new Promise(r => setTimeout(r, 1000))
	 
	 // return await fetch(`https://nominatim.openstreetmap.org/search?street=${address}&postalcode=${codePostal}&city=${ville}&country=${pays}&format=json`, {
	 return await fetch(`https://nominatim.openstreetmap.org/search?q=${address}&format=json`, {
	 method: 'GET'
	 }).then((response) =>
	 {
	 return response.ok ? response.json() : Promise.reject(response.statusText)
	 }).then((response) =>
	 {
	 if (!response)
	 {
	 return
	 }
	 
	 return [response[0].lat, response[0].lon]
	 }).catch((error) =>
	 {
	 alert(error)
	 })
	 }*/
}
